module.exports = __webpack_public_path__ + "static/media/icon-produto.8f68f5aa.svg";